exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.go-back.back-outline[data-v-754b0e81] {\n  background-color: transparent;\n  border: 1px solid #085FCE;\n  color: #085FCE;\n  border-radius: 8px;\n  padding-right: 8px;\n}\nbutton.go-back[data-v-754b0e81] {\n  color: #085FCE;\n  display: flex;\n  align-items: center;\n  font-weight: 400;\n  font-size: 15px;\n}", ""]);

// exports
